import React, { useRef, useEffect } from "react";

/**
 * Hook that alerts clicks outside of the passed ref
 */
function useOutsideAlerter(ref, setMenuButton) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setMenuButton(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setMenuButton]);
}

/**
 * Component that alerts if you click outside of it
 */
function OutsideAlerter({ setMenuButton, ...props }) {
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, setMenuButton);

  return <div ref={wrapperRef}>{props.children}</div>;
}

export default OutsideAlerter;
